window.roomInfo = null;

window.msgArray = [];
window.msgpos = 0;
window.msgTimerID = null;

window.startwatch = function () {
    showWait();
    var id = $('.roominfo').data('id');
    var type = $('.roominfo').data('type');
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/' + (type == 1 ? 'personalshows' : 'activityshows') + '/' + id + '/playback',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    var urls = [];
                    var logfile = '';
                    if (result.length > 0) {
                        if (type == 2) {
                            result = result[0].files;
                        }
                        for (var i = 0; i < result.length; i++) {
                            if (result[i].type == 1) {
                                logfile = result[i].file_url;
                                continue;
                            }

                            var urlmp4 = '';
                            var urlflv = '';
                            var urlm3u8 = '';
                            var urlother = '';

                            $.each(result[i].file_extra_urls, function (i, val) {
                                var path = val;
                                var ext = getext(path);
                                // if (ext == 'mp4') {
                                //     urlmp4 = path;
                                // } else if (ext == 'flv') {
                                //     urlflv = path;
                                // } else {
                                //     urlother = path;
                                // }

                                if (ext == 'm3u8') {
                                    urlm3u8 = path;
                                }
                            });

                            if (urlmp4.length > 0) {
                                urls.push(urlmp4);
                            } else if (urlflv.length > 0) {
                                urls.push(urlflv);
                            } else if (urlm3u8.length > 0) {
                                urls.push(urlm3u8);
                            } else if (urlother.length > 0) {
                                urls.push(urlother);
                            } else {
                                urls.push(result[i].file_url);
                            }

                            var ext = getext(result[i].file_url);
                            if (ext == 'm3u8') {
                                urls.push(result[i].file_url);
                            }
                        }
                    }

                    if (urls.length > 0) {
                        startPlay(urls[0], 'content');

                        if (msgTimerID) {
                            clearTimeout(msgTimerID);
                        }
                    }
                } else {
                    alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

window.enterroom = function () {
    var id = $('.roominfo').data('id');
    var data = {
        password: ''
    };
    $.ajax({
        type: 'post',
        async: true,
        url: ROOT + '/channels/' + id + '/enter-room',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    // $('#passworddlg').modal('hide');
                    roomInfo = result;

                    // getChatMsg();
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
        }
    });
};

window.getChatMsg = function () {
    var id = $('.roominfo').data('id');

    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/shows/' + id + '/room/chat/messages?max=1000&before=0',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        headers: {
            'X-DFSX-RoomId': roomInfo.room_id
        },
        success: function (result) {
            var lastdate = null;

            for (var i = (result.length - 1); i >= 0; i--) {
                var info = result[i];
                if (info.type != 'chat_message') {
                    continue;
                }

                var msgdate = new Date(info.timestamp * 1000);
                if (lastdate == null) {
                    lastdate = msgdate;
                }

                var datediff = (msgdate.getTime() - lastdate.getTime());

                var msg = info.body;
                if (msg) {
                    msgArray.push({
                        'datediff': datediff,
                        'msg': msg
                    });
                }
            }

            showLogMsg();
        },
        error: function (error) {
            console.log(error);
        }
    });
};

window.showlog = function (logfile) {
    $.ajax({
        url: ROOT + logfile,
        async: false,
        cache: false,
        dataType: 'text',
        success: function (result, textStatus, jqXHR) {
            try {
                var content = result;
                var patt = /\[[0-2][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9] [0-2][0-9]:[0-5][0-9]:[0-5][0-9]\]/;
                var result = null;
                var msgs = [];
                if ((result = content.split(patt)) != null) {
                    msgs = result;
                }

                var patt2 = new RegExp('\[[0-2][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9] [0-2][0-9]:[0-5][0-9]:[0-5][0-9]', 'gim');

                var dates = [];
                while ((result = patt2.exec(content)) != null) {
                    var substrs = result;
                    dates.push(substrs[0]);

                }

                var obj = {};
                if (msgs.length > 0 && dates.length > 0) {
                    if (msgs[0].length == 0) {
                        msgs.shift();
                    }

                    for (var i = 0; i < msgs.length; i++) {
                        obj[dates[i]] = msgs[i];
                    }
                }
                parselog(obj);
            } catch (e) {
                console.log('解析文件失败, ' + e.message);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

window.showLogMsg = function () {
    for (var i = msgpos; i < msgArray.length; i++) {
        var timeout = msgArray[i].datediff;

        msgpos++;
        msgTimerID = setTimeout('showLogMsg()', timeout);

        // showPlayMsg(msgArray[i].msg);
        break;
    }
};

window.parselog = function (content) {
    var currentdate = new Date();
    var pos = null;
    var lastdate = null;

    $.each(content, function (index, value, array) {
        var msgdate = new Date(index);
        if (pos == null) {
            pos = currentdate - msgdate;
            lastdate = msgdate;
        }
        var xmlString = value;
        var msg = paresemsg(xmlString);

        var datediff = (msgdate.getTime() - lastdate.getTime());

        if (msg) {
            msgArray.push({
                'datediff': datediff,
                'msg': msg
            });
        }
    });

    showLogMsg();
};

window.paresemsg = function (xmlString) {
    var xmlDoc = null;
    try {
        // Internet Explorer
        xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
        xmlDoc.async = 'false';
        xmlDoc.loadXML(xmlString);
    } catch (e) {
        // Firefox, Mozilla, Opera, etc.
        try {
            parser = new DOMParser();
            xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        } catch (e) {
            xmlDoc = null;
            console.log(e.message);
        }
    }

    if (!xmlDoc) {
        console.log('加载xml失败');
        return;
    }


    var elements = xmlDoc.getElementsByTagName('message');

    var msg = null;

    if (elements.length > 0) {
        for (var i = 0; i < elements.length; i++) {
            try {
                msg = elements[i].getElementsByTagName('body')[0].firstChild.nodeValue;
            } catch (e) {
            }
            break;
        }
    }

    return msg;
};

startwatch();

gethotest(9);

enterroom();